// opervex-frontend/src/Opervex/Accounting/Vendors.js

class Vendors {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async findAll() {
    return this.#_api.get("/Accounting/Vendors");
  }

  async findId(id) {
    return this.#_api.get(`/Accounting/Vendors/${id}`);
  }

  async create(data) {
    return this.#_api.post("/Accounting/Vendors", data);
  }

  async update(id, data) {
    return this.#_api.put(`/Accounting/Vendors/${id}`, data);
  }

  async schema() {
    return [
      { key: "id", label: "Código", type: "number", visible: true },
      { key: "name", label: "Nome / razão social", type: "string", visible: true },
      { key: "document", label: "CPF / CNPJ", type: "string", visible: true },
      { key: "disabled", label: "Inativo", type: "boolean", visible: true },
    ];
  }
}

export default Vendors;
